export { Caption } from './Caption.styles';
